import { useInfiniteQuery } from '@tanstack/react-query';

import { $apiV2, infinityNextPageParam, IWithPagination } from 'modules/global';

import { courseConst, ITeacher } from '..';

interface IReqProps {
  search?: string;
  enabled?: boolean;
}

export const fetchTeachersSitemap = async () => {
  const { data } = await $apiV2.get('/teacher/view', {
    params: { size: 32 }
  });

  return data;
};

export const getTeachers =
  ({ search }: IReqProps) =>
  async ({ pageParam = 1 }) => {
    const { data } = await $apiV2.get('/teacher/view', {
      params: { page: pageParam, search, size: 32 }
    });

    return data;
  };

export const useTeachers = ({ search, enabled }: IReqProps) => {
  const query = useInfiniteQuery<IWithPagination<ITeacher[]>>({
    queryKey: [courseConst.queryKeys.TEACHERS, search],
    queryFn: getTeachers({ search }),
    getNextPageParam: infinityNextPageParam<IWithPagination<ITeacher[]>>(32),
    enabled
  });

  const teachers = query.data?.pages.flatMap(page => page.data) ?? [];

  return { ...query, teachers };
};
